<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="aluno-voltar"
            data-testid="aluno-voltar"
            color="primary"
            x-small
            text
            :disabled="submittingForm"
            @click="() => $router.push({ name: 'alunos' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }}&nbsp;Aluno
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs
                v-model="tab"
                background-color="deep-purple accent-4"
                centered
                dark
                icons-and-text
              >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-1">
                  Aluno
                  <v-icon>fa-graduation-cap</v-icon>
                </v-tab>

                <v-tab href="#tab-3">
                  Endereço do Aluno
                  <v-icon>fa-address-card</v-icon>
                </v-tab>

                <v-tab href="#tab-4">
                  Responsável Financeiro
                  <v-icon>mdi-account-box</v-icon>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item :value="'tab-1'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" v-if="isInitial || isSaving">
                          <h4>Carregar imagem</h4>
                          <div class="dropbox">
                            <input
                              type="file"
                              :name="uploadFieldName"
                              @change="filesChange($event.target.files)"
                              accept="image/*"
                              class="input-file"
                            />
                            <p v-if="isInitial">
                              Arraste uma imagem aqui para começar<br />
                              ou clique para navegar
                            </p>
                            <p v-if="isSaving" class="text-center">Imagem carregada!</p>
                          </div>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="8">
                          <ValidationProvider
                            name="Nome Completo do Aluno"
                            ref="nomecompleto"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>Nome Completo</e-label>

                            <v-text-field
                              id="aluno-nomecompleto"
                              data-testid="aluno-nomecompleto"
                              v-model="form.nomecompleto"
                              label="Nome Completo"
                              type="text"
                              dense
                              solo
                              :maxlength="TAMANHO_NOME"
                              :counter="TAMANHO_NOME"
                              :error-messages="[
                                ...errors,
                                ...errosDeCaractere['form.nomecompleto'],
                              ]"
                              @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                              @compositionend.native="
                                (event) =>
                                  sanitizarNome(
                                    'form.nomecompleto',
                                    event.target.value,
                                    TAMANHO_NOME
                                  )
                              "
                              @beforeinput="bloquearEmoji"
                              @input="
                                (valor) => sanitizarNome('form.nomecompleto', valor, TAMANHO_NOME)
                              "
                            />
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label>Código Único(INEP)</e-label>

                          <v-text-field
                            id="aluno-inep"
                            data-testid="aluno-inep"
                            v-model="form.codigo_inep"
                            label="INEP"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_INEP"
                            :counter="TAMANHO_INEP"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNumero(
                                  'form.codigo_inep',
                                  event.target.value,
                                  TAMANHO_INEP
                                )
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarNumero('form.codigo_inep', valor, TAMANHO_INEP)
                            "
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <ValidationProvider
                            name="Data de nascimento"
                            rules="required"
                            ref="dataNascimento"
                            v-slot="{ errors }"
                          >
                            <e-label>Data de nascimento</e-label>
                            <e-date-picker
                              id="aluno-data-nascimento"
                              data-testid="aluno-data-nascimento"
                              :error-messages="errors"
                              v-model="form.data_nascimento"
                              placeholder="dd/mm/yyyy"
                              dense
                              solo
                            ></e-date-picker>
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Sexo</e-label>
                          <e-autocomplete
                            id="aluno-sexo"
                            data-testid="aluno-sexo"
                            :items="$constants.sexoList"
                            :return-object="false"
                            :item-text="(item) => item.descricao"
                            :item-value="(item) => item.id"
                            v-model="form.sexo_id"
                            label="Selecione uma opção"
                            clearable
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Nacionalidade</e-label>
                          <e-autocomplete
                            id="aluno-nacionalidade"
                            data-testid="aluno-nacionalidade"
                            :items="$constants.nacionalidadeList"
                            :return-object="false"
                            :item-text="(item) => item"
                            :item-value="(item) => item"
                            v-model="form.nacionalidade"
                            label="Selecione uma opção"
                            clearable
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>UF de nascimento aluno</e-label>
                          <e-autocomplete
                            id="aluno-uf-nascimento"
                            data-testid="aluno-uf-nascimento"
                            :items="$constants.estadosList"
                            :return-object="false"
                            :item-text="(item) => item.codigo"
                            :item-value="(item) => item.id"
                            v-model="form.estadonasc_id"
                            @change="(event) => atualizarEstado(event)"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Local de nascimento</e-label>
                          <e-autocomplete
                            id="aluno-municipio-nascimento"
                            data-testid="aluno-municipio-nascimento"
                            :items="municipiosNascimentoList"
                            :return-object="false"
                            :item-text="(item) => item"
                            :item-value="(item) => item"
                            v-model="form.municipio_nas"
                            @change="(event) => atualizarNaturalidade(event)"
                            @click.native="avisarUfNascimentoPendente"
                            @focusin.native="avisarUfNascimentoPendente"
                            no-data-text="Selecione a UF de nascimento"
                            label="Selecione uma cidade"
                            clearable
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Número do CPF</e-label>

                          <v-text-field
                            id="aluno-cpf"
                            data-testid="aluno-cpf"
                            v-model="form.cpf"
                            v-mask="'###.###.###-##'"
                            label="CPF"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CPF"
                            :counter="TAMANHO_CPF"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) => sanitizarTexto('form.cpf', event.target.value, TAMANHO_CPF)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarTexto('form.cpf', valor, TAMANHO_CPF)"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>RG</e-label>

                          <v-text-field
                            id="aluno-rg"
                            data-testid="aluno-rg"
                            v-model="form.registrogeral"
                            v-mask="'##.###.###-###'"
                            label="RG"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_RG"
                            :counter="TAMANHO_RG"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto('form.registrogeral', event.target.value, TAMANHO_RG)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarTexto('form.registrogeral', valor, TAMANHO_RG)
                            "
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Celular do Aluno</e-label>

                          <v-text-field
                            id="aluno-celular"
                            data-testid="aluno-celular"
                            v-model="form.celular_aluno_1"
                            v-mask="'(##) # ####-####'"
                            label="Celular"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CELULAR"
                            :counter="TAMANHO_CELULAR"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto(
                                  'form.celular_aluno_1',
                                  event.target.value,
                                  TAMANHO_CELULAR
                                )
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) =>
                                sanitizarTexto('form.celular_aluno_1', valor, TAMANHO_CELULAR)
                            "
                          />
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Nome do Pai</e-label>

                          <v-text-field
                            id="aluno-filiacao1"
                            data-testid="aluno-filiacao1"
                            v-model="form.filiacao1"
                            label="Nome do Pai"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_NOME"
                            :counter="TAMANHO_NOME"
                            :error-messages="errosDeCaractere['form.filiacao1']"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNome('form.filiacao1', event.target.value, TAMANHO_NOME)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarNome('form.filiacao1', valor, TAMANHO_NOME)"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>CPF do Pai</e-label>

                          <v-text-field
                            id="aluno-cpf-pai"
                            data-testid="aluno-cpf-pai"
                            v-model="form.cpf_pai"
                            v-mask="'###.###.###-##'"
                            label="CPF do Pai"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CPF"
                            :counter="TAMANHO_CPF"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto('form.cpf_pai', event.target.value, TAMANHO_CPF)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarTexto('form.cpf_pai', valor, TAMANHO_CPF)"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Celular do Pai</e-label>

                          <v-text-field
                            id="aluno-celular-pai"
                            data-testid="aluno-celular-pai"
                            v-model="form.celular_pai"
                            v-mask="'(##) # ####-####'"
                            label="Celular do Pai"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CELULAR"
                            :counter="TAMANHO_CELULAR"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto(
                                  'form.celular_pai',
                                  event.target.value,
                                  TAMANHO_CELULAR
                                )
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarTexto('form.celular_pai', valor, TAMANHO_CELULAR)
                            "
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Nome da Mãe</e-label>

                          <v-text-field
                            id="aluno-filiacao2"
                            data-testid="aluno-filiacao2"
                            v-model="form.filiacao2"
                            label="Nome da Mãe"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_NOME"
                            :counter="TAMANHO_NOME"
                            :error-messages="errosDeCaractere['form.filiacao2']"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNome('form.filiacao2', event.target.value, TAMANHO_NOME)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarNome('form.filiacao2', valor, TAMANHO_NOME)"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>CPF da Mãe</e-label>

                          <v-text-field
                            id="aluno-cpf-mae"
                            data-testid="aluno-cpf-mae"
                            v-model="form.cpf_mae"
                            v-mask="'###.###.###-##'"
                            label="CPF da Mãe"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CPF"
                            :counter="TAMANHO_CPF"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto('form.cpf_mae', event.target.value, TAMANHO_CPF)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarTexto('form.cpf_mae', valor, TAMANHO_CPF)"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Celular da Mãe</e-label>

                          <v-text-field
                            id="aluno-celular-mae"
                            data-testid="aluno-celular-mae"
                            v-model="form.celular_mae"
                            v-mask="'(##) # ####-####'"
                            label="Celular da Mãe"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CELULAR"
                            :counter="TAMANHO_CELULAR"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto(
                                  'form.celular_mae',
                                  event.target.value,
                                  TAMANHO_CELULAR
                                )
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarTexto('form.celular_mae', valor, TAMANHO_CELULAR)
                            "
                          />
                        </v-col>

                        <v-col cols="12">
                          <v-btn
                            id="aluno-tab1-proximo"
                            data-testid="aluno-tab1-proximo"
                            color="primary"
                            @click="changeTab(3)"
                            block
                            >Próximo</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item :value="'tab-2'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <h4>
                            DEFICIÊNCIA/TRANSTORNOS GLOBAIS DE DESENVOLVIMENTO/ALTAS HABILIDADES
                          </h4>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tipo aluno(a)</e-label>
                          <e-autocomplete
                            id="aluno-tipo"
                            data-testid="aluno-tipo"
                            :items="['Típico', 'Atípico']"
                            v-model="form.tipo_aluno"
                            label="Selecione uma opção"
                            :return-object="false"
                            :item-text="(value) => value"
                            :item-value="(value) => value"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col cols="8"></v-col>
                      </v-row>

                      <v-row>
                        <transition name="fade">
                          <v-col cols="12" class="pt-0 pb-0" v-if="form.tipo_aluno === 'Atípico'">
                            <v-row>
                              <v-col cols="6">
                                <e-label>Descrição:</e-label>

                                <v-text-field
                                  id="aluno-diagnostico"
                                  data-testid="aluno-diagnostico"
                                  v-model="form.diagnostico"
                                  label="Descrição"
                                  type="text"
                                  dense
                                  solo
                                  :maxlength="TAMANHO_TEXTO"
                                  :counter="TAMANHO_TEXTO"
                                  :error-messages="errosDeCaractere['form.diagnostico']"
                                  @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                                  @compositionend.native="
                                    (event) =>
                                      sanitizarNome(
                                        'form.diagnostico',
                                        event.target.value,
                                        TAMANHO_TEXTO
                                      )
                                  "
                                  @beforeinput="bloquearEmoji"
                                  @input="
                                    (valor) =>
                                      sanitizarNome('form.diagnostico', valor, TAMANHO_TEXTO)
                                  "
                                />
                              </v-col>
                            </v-row>
                          </v-col>
                        </transition>
                      </v-row>

                      <v-row>
                        <v-col class="pt-0 pb-0" cols="12">
                          <h4>DADOS SOBRE A SAÚDE</h4>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tem alergia(s)?</e-label>
                          <v-select
                            id="aluno-tem-alergia"
                            data-testid="aluno-tem-alergia"
                            v-model="selectedItemSaude"
                            :items="itemsAlergia"
                            label="Selecione uma opção"
                            clearable
                            dense
                            solo
                            @change="limparDetalheDeSaude"
                          />
                        </v-col>
                        <v-col cols="8"></v-col>

                        <transition name="fade">
                          <v-col cols="12" class="pt-0 pb-0" v-if="selectedItemSaude === 'Sim'">
                            <v-row>
                              <v-col cols="6">
                                <e-label>Tipos(s):</e-label>

                                <v-text-field
                                  id="aluno-saude-detalhe"
                                  data-testid="aluno-saude-detalhe"
                                  v-model="textFieldValueDetalhe"
                                  label="Descrição"
                                  type="text"
                                  dense
                                  solo
                                  :maxlength="TAMANHO_TEXTO"
                                  :counter="TAMANHO_TEXTO"
                                  :error-messages="errosDeCaractere.textFieldValueDetalhe"
                                  @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                                  @compositionend.native="
                                    (event) =>
                                      sanitizarNome(
                                        'textFieldValueDetalhe',
                                        event.target.value,
                                        TAMANHO_TEXTO
                                      )
                                  "
                                  @beforeinput="bloquearEmoji"
                                  @input="
                                    (valor) =>
                                      sanitizarNome('textFieldValueDetalhe', valor, TAMANHO_TEXTO)
                                  "
                                />
                              </v-col>
                            </v-row>
                          </v-col>
                        </transition>

                        <v-col cols="6">
                          <v-btn
                            id="aluno-tab2-anterior"
                            data-testid="aluno-tab2-anterior"
                            color="primary"
                            @click="changeTab(1)"
                            block
                            >Anterior</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="aluno-tab2-proximo"
                            data-testid="aluno-tab2-proximo"
                            color="primary"
                            @click="changeTab(3)"
                            block
                            >Próximo</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item :value="'tab-3'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <h4>DADOS SOBRE O ENDEREÇO DO(A) ALUNO(A)</h4>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Endereço</e-label>

                          <v-text-field
                            id="aluno-endereco"
                            data-testid="aluno-endereco"
                            v-model="form.endereco"
                            label="Endereço"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_ENDERECO"
                            :counter="TAMANHO_ENDERECO"
                            :error-messages="errosDeCaractere['form.endereco']"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNome('form.endereco', event.target.value, TAMANHO_ENDERECO)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarNome('form.endereco', valor, TAMANHO_ENDERECO)
                            "
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="2">
                          <e-label>Número</e-label>

                          <v-text-field
                            id="aluno-numero"
                            data-testid="aluno-numero"
                            v-model="form.numero"
                            label="Número"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_NUMERO"
                            :counter="TAMANHO_NUMERO"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNumero('form.numero', event.target.value, TAMANHO_NUMERO)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) => sanitizarNumero('form.numero', valor, TAMANHO_NUMERO)
                            "
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label>Bairro</e-label>

                          <v-text-field
                            id="aluno-bairro"
                            data-testid="aluno-bairro"
                            v-model="form.bairro"
                            label="Bairro"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_BAIRRO"
                            :counter="TAMANHO_BAIRRO"
                            :error-messages="errosDeCaractere['form.bairro']"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                            @compositionend.native="
                              (event) =>
                                sanitizarNome('form.bairro', event.target.value, TAMANHO_BAIRRO)
                            "
                            @beforeinput="bloquearEmoji"
                            @input="(valor) => sanitizarNome('form.bairro', valor, TAMANHO_BAIRRO)"
                          />
                        </v-col>

                        <v-col cols="6">
                          <v-btn
                            id="aluno-tab3-anterior"
                            data-testid="aluno-tab3-anterior"
                            color="primary"
                            @click="changeTab(2)"
                            block
                            >Anterior</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="aluno-tab3-proximo"
                            data-testid="aluno-tab3-proximo"
                            color="primary"
                            @click="changeTab(4)"
                            block
                            >Próximo</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item :value="'tab-4'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col class="pt-0 pb-0" cols="12">
                          <ValidationProvider
                            name="Nome Completo do Responsavel"
                            ref="nomeResponsavel"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>Responsavel Financeiro</e-label>

                            <v-text-field
                              id="aluno-responsavel-nome"
                              data-testid="aluno-responsavel-nome"
                              v-model="responsavel.descricao"
                              label="Responsável Financeiro"
                              type="text"
                              dense
                              solo
                              :maxlength="TAMANHO_NOME_RESPONSAVEL"
                              :counter="TAMANHO_NOME_RESPONSAVEL"
                              :error-messages="[
                                ...errors,
                                ...errosDeCaractere['responsavel.descricao'],
                              ]"
                              @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
                              @compositionend.native="
                                (event) =>
                                  sanitizarNome(
                                    'responsavel.descricao',
                                    event.target.value,
                                    TAMANHO_NOME_RESPONSAVEL
                                  )
                              "
                              @beforeinput="bloquearEmoji"
                              @input="
                                (valor) =>
                                  sanitizarNome(
                                    'responsavel.descricao',
                                    valor,
                                    TAMANHO_NOME_RESPONSAVEL
                                  )
                              "
                            />
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <ValidationProvider
                            name="CPF do Responsavel"
                            ref="cpfResponsavel"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>CPF</e-label>

                            <v-text-field
                              id="aluno-responsavel-cpf"
                              data-testid="aluno-responsavel-cpf"
                              v-model="responsavel.cpf"
                              v-mask="'###.###.###-##'"
                              label="CPF"
                              type="text"
                              dense
                              solo
                              :maxlength="TAMANHO_CPF"
                              :counter="TAMANHO_CPF"
                              :error-messages="errors"
                              @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                              @compositionend.native="
                                (event) =>
                                  sanitizarTexto('responsavel.cpf', event.target.value, TAMANHO_CPF)
                              "
                              @beforeinput="bloquearEmoji"
                              @input="
                                (valor) => sanitizarTexto('responsavel.cpf', valor, TAMANHO_CPF)
                              "
                            />
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <ValidationProvider
                            name="CEP do Responsável"
                            ref="cepResponsavel"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>CEP</e-label>

                            <v-text-field
                              id="aluno-responsavel-cep"
                              data-testid="aluno-responsavel-cep"
                              v-model="responsavel.cep"
                              v-mask="'##.###-###'"
                              label="CEP"
                              type="text"
                              dense
                              solo
                              :maxlength="TAMANHO_CEP"
                              :counter="TAMANHO_CEP"
                              :error-messages="errors"
                              @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                              @compositionend.native="
                                (event) =>
                                  sanitizarTexto('responsavel.cep', event.target.value, TAMANHO_CEP)
                              "
                              @beforeinput="bloquearEmoji"
                              @input="
                                (valor) => sanitizarTexto('responsavel.cep', valor, TAMANHO_CEP)
                              "
                            />
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="12">
                          <e-label>Contato</e-label>

                          <v-text-field
                            id="aluno-responsavel-celular"
                            data-testid="aluno-responsavel-celular"
                            v-model="responsavel.celular1"
                            v-mask="'(##) # ####-####'"
                            label="Contato"
                            type="text"
                            dense
                            solo
                            :maxlength="TAMANHO_CELULAR"
                            :counter="TAMANHO_CELULAR"
                            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
                            @compositionend.native="
                              (event) =>
                                sanitizarTexto(
                                  'responsavel.celular1',
                                  event.target.value,
                                  TAMANHO_CELULAR
                                )
                            "
                            @beforeinput="bloquearEmoji"
                            @input="
                              (valor) =>
                                sanitizarTexto('responsavel.celular1', valor, TAMANHO_CELULAR)
                            "
                          />
                        </v-col>

                        <v-col cols="6">
                          <v-btn
                            id="aluno-tab4-anterior"
                            data-testid="aluno-tab4-anterior"
                            color="primary"
                            @click="changeTab(3)"
                            block
                            >Anterior</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="aluno-salvar"
                            data-testid="aluno-salvar"
                            color="primary"
                            :disabled="submittingForm"
                            :loading="submittingForm"
                            @click="validarCamposObrigatorios"
                            block
                            >Enviar Dados</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const CAMPOS_OBRIGATORIOS = [
  { ref: "nomecompleto", tab: 1 },
  { ref: "dataNascimento", tab: 1 },
  { ref: "nomeResponsavel", tab: 4 },
  { ref: "cpfResponsavel", tab: 4 },
  { ref: "cepResponsavel", tab: 4 },
];

const CLASSE_NOME = "A-Za-zÀ-ÖØ-öø-ÿ0-9 .,'\\-&/()ºª©®™";
const CLASSE_NUMERO = "0-9";

/**
 * Tamanhos espelham os limites das colunas em `alunos` e `responsavels`; nos
 * campos com máscara vale a quantidade de caracteres da própria máscara.
 */
const TAMANHO_BAIRRO = 64;
const TAMANHO_CELULAR = 16;
const TAMANHO_CEP = 10;
const TAMANHO_CPF = 14;
const TAMANHO_ENDERECO = 255;
const TAMANHO_INEP = 12;
const TAMANHO_NOME = 160;
const TAMANHO_NOME_RESPONSAVEL = 64;
const TAMANHO_NUMERO = 7;
const TAMANHO_RG = TAMANHO_CPF;
const TAMANHO_TEXTO = 255;

const MENSAGEM_CARACTERE_REMOVIDO = "Caracteres não permitidos foram removidos.";
const REGEX_EMOJI =
  /[\uD800-\uDFFF]|[\u2190-\u21FF\u2300-\u27BF\u2934\u2935\u2B00-\u2BFF\u3030\u303D\u3297\u3299]|\uFE0F|\u200D|\u20E3/g;

const removerCaracteresInvalidos = (valor, classe) =>
  `${valor ?? ""}`.replace(new RegExp(`[^${classe}]`, "g"), "");

const removerEmojis = (valor) => `${valor ?? ""}`.replace(REGEX_EMOJI, "");

export default {
  name: "AlunoForm",

  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CLASSE_NOME,
      CLASSE_NUMERO,
      currentStatus: STATUS_INITIAL,
      errosDeCaractere: {
        "form.bairro": [],
        "form.diagnostico": [],
        "form.endereco": [],
        "form.filiacao1": [],
        "form.filiacao2": [],
        "form.nomecompleto": [],
        "responsavel.descricao": [],
        textFieldValueDetalhe: [],
      },
      form: {
        cpf: null,
        estadonasc_id: null,
        municipio_nas: null,
        nacionalidade: "Brasileira",
        naturalidade: null,
        registrogeral: null,
        sexo_id: null,
      },
      imageAluno: null,
      irmaos: [],
      itemsAlergia: ["Sim", "Não"],
      municipiosNasc: [],
      nextInepTimeoutCall: null,
      recursos_saeb: [],
      responsavel: {
        descricao: " ",
      },
      selectedItemSaude: null,
      submittingForm: false,
      tab: "",
      TAMANHO_BAIRRO,
      TAMANHO_CELULAR,
      TAMANHO_CEP,
      TAMANHO_CPF,
      TAMANHO_ENDERECO,
      TAMANHO_INEP,
      TAMANHO_NOME,
      TAMANHO_NOME_RESPONSAVEL,
      TAMANHO_NUMERO,
      TAMANHO_RG,
      TAMANHO_TEXTO,
      textFieldValueDetalhe: "",
      uploadFieldName: "photos",
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),

    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },

    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },

    municipiosNascimentoList() {
      const cidades = this.municipiosNasc ?? [];
      const cidadeAtual = this.form.municipio_nas;

      return cidadeAtual && !cidades.includes(cidadeAtual) ? [cidadeAtual, ...cidades] : cidades;
    },
  },

  watch: {
    form: {
      deep: true,
      handler() {
        if (this.nextInepTimeoutCall) {
          clearTimeout(this.nextInepTimeoutCall);
        }
        this.nextInepTimeoutCall = setTimeout(() => {
          this.verificarCodigoINEP();
        }, 500);
      },
    },
  },

  mounted() {
    this.loadFormData();
  },

  methods: {
    changeTab(tabindex) {
      this.tab = `tab-${tabindex}`;
    },

    /**
     * Impede a digitação de caracteres fora da classe permitida do campo.
     * --
     * @param {KeyboardEvent} event - Evento de tecla
     * @param {string} classe - Classe de caracteres aceitos
     */
    bloquearCaractere(event, classe) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;

      const tecla = event.key;
      if (!tecla || tecla.length !== 1) return;

      if (!new RegExp(`^[${classe}]$`).test(tecla)) {
        event.preventDefault();
      }
    },

    /**
     * Impede a inserção de emojis, inclusive por colagem ou teclado virtual.
     * --
     * @param {InputEvent} event - Evento de entrada
     */
    bloquearEmoji(event) {
      if (event.data && /\p{Extended_Pictographic}/u.test(event.data)) {
        event.preventDefault();
      }
    },

    /**
     * Escreve o valor sanitizado no campo. Recebe o caminho porque os dados do
     * formulário estão divididos entre `form`, `responsavel` e o próprio
     * componente.
     * --
     * @param {string} caminho - Caminho do campo, ex: "responsavel.cpf"
     * @param {string} valor - Valor já sanitizado
     */
    definirCampo(caminho, valor) {
      const partes = caminho.split(".");
      const campo = partes.pop();
      const destino = partes.reduce((objeto, chave) => objeto[chave], this);

      destino[campo] = valor;
    },

    /**
     * Remove os caracteres fora da classe de nomes e avisa o usuário quando
     * algo foi descartado.
     * --
     * @param {string} caminho - Caminho do campo
     * @param {string} valor - Valor digitado
     * @param {number} tamanho - Quantidade máxima de caracteres
     */
    sanitizarNome(caminho, valor, tamanho) {
      const limpo = removerCaracteresInvalidos(removerEmojis(valor), CLASSE_NOME).slice(0, tamanho);

      this.errosDeCaractere[caminho] =
        limpo === `${valor ?? ""}` ? [] : [MENSAGEM_CARACTERE_REMOVIDO];
      this.definirCampo(caminho, limpo);
    },

    /**
     * Mantém apenas dígitos no campo, respeitando o tamanho máximo.
     * --
     * @param {string} caminho - Caminho do campo
     * @param {string} valor - Valor digitado
     * @param {number} tamanho - Quantidade máxima de dígitos
     */
    sanitizarNumero(caminho, valor, tamanho) {
      const limpo = removerCaracteresInvalidos(valor, CLASSE_NUMERO).slice(0, tamanho);

      this.definirCampo(caminho, limpo);
    },

    /**
     * Campos com `v-mask`: a máscara já cuida do formato, aqui só barramos
     * emojis e o excesso de caracteres.
     * --
     * @param {string} caminho - Caminho do campo
     * @param {string} valor - Valor digitado
     * @param {number} tamanho - Quantidade máxima de caracteres
     */
    sanitizarTexto(caminho, valor, tamanho) {
      this.definirCampo(caminho, removerEmojis(valor).slice(0, tamanho));
    },

    async validarCamposObrigatorios() {
      const resultados = await Promise.all(
        CAMPOS_OBRIGATORIOS.map(async (campo) => {
          const provider = this.$refs[campo.ref];
          if (!provider) return { ...campo, valid: true, errors: [] };

          const { valid, errors } = await provider.validate();
          return { ...campo, valid, errors };
        })
      );

      const primeiroInvalido = resultados.find((resultado) => !resultado.valid);
      if (primeiroInvalido) {
        this.$toast.danger(primeiroInvalido.errors[0]);
        this.changeTab(primeiroInvalido.tab);

        return;
      }

      await this.submitForm();
    },

    carregarMunicipiosNascimento(estadoId) {
      const uf = this.$constants.estadosList.find((item) => item.id === Number(estadoId));
      this.municipiosNasc = this.$constants.municipios[uf?.codigo]?.cidades ?? [];
    },

    atualizarEstado(value) {
      this.carregarMunicipiosNascimento(value);
      this.form.municipio_nas = null;
      this.form.naturalidade = null;
    },

    atualizarNaturalidade(municipio) {
      this.form.naturalidade = municipio ?? null;
    },

    /**
     * A lista de cidades só é carregada depois da UF, então o campo abre vazio
     * enquanto ela não for escolhida. O `no-data-text` não resolve aqui porque
     * o `e-autocomplete` força `hide-no-data`; o aviso vai por toast.
     */
    avisarUfNascimentoPendente() {
      if (this.form.estadonasc_id) return;

      this.$toast.warn("Selecione a UF de nascimento para escolher o local de nascimento");
    },

    limparDetalheDeSaude() {
      if (!this.selectedItemSaude) {
        this.textFieldValueDetalhe = "";
      }
    },

    async getResponsavel(responsavel_id) {
      try {
        return await this.$services.alunosService.getResponsavel(responsavel_id);
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async pegarAluno() {
      try {
        const { aluno_id } = this.$route.params;
        return await this.$services.alunosService.pegarAluno(aluno_id);
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async submitForm() {
      this.submittingForm = true;

      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.form.irmaos = this.irmaos;

      if (this.form.municipio_nas) {
        this.form.naturalidade = this.form.municipio_nas;
      }
      this.preencherDadosDeSaude();

      try {
        this.form.responsavel_id = await this.$services.alunosService.criaOuAtualizaResposavel(
          this.responsavel
        );
      } catch (error) {
        this.submittingForm = false;
        this.$toast.danger(error?.error?.message ?? "Os dados informados estão invalidos");
        return;
      }

      try {
        const aluno = this.editing
          ? await this.$services.alunosService.atualizarAluno(this.form)
          : await this.$services.alunosService.criarAluno(this.form);

        await this.uploadImage(aluno.id);

        this.$toast.success(
          this.editing ? "Aluno(a) Atualizado(a) com sucesso" : "Aluno(a) criado(a) com sucesso"
        );
        this.$router.push({ name: "alunos" });
      } catch (error) {
        this.$toast.danger(error?.error?.message ?? "Os dados informados estão invalidos");
      } finally {
        this.submittingForm = false;
      }
    },

    preencherDadosDeSaude() {
      this.form.selectedItemSaude = this.selectedItemSaude;
      this.form.saude_detalhe = this.selectedItemSaude === "Sim" ? this.textFieldValueDetalhe : " ";
    },

    async loadFormData() {
      if (!this.editing) return;

      const aluno = await this.pegarAluno();
      if (!aluno) return;

      const responsavel = await this.getResponsavel(aluno.responsavel_id);

      if (aluno.imagem) {
        this.currentStatus = STATUS_SAVING;
      }

      this.recursos_saeb = aluno.recursos_saeb ?? [];
      this.form = { ...aluno };
      this.responsavel = { ...(responsavel?.[0] ?? {}) };
      this.carregarMunicipiosNascimento(aluno.estadonasc_id);
      this.selectedItemSaude = aluno.selectedItemSaude;
      this.textFieldValueDetalhe = aluno.saude_detalhe;
    },

    async uploadImage(id) {
      try {
        await this.$services.imageService.uploadImage("alunos/upload-image", this.imageAluno, id);
      } catch (error) {
        this.$handleError(error);
      }
    },

    filesChange(fileList) {
      if (!fileList.length) return;

      [this.imageAluno] = fileList;
      this.currentStatus = STATUS_SAVING;
    },

    async verificarCodigoINEP() {
      if (this.editing || !this.form.codigo_inep) return;

      try {
        const aluno = await this.$services.alunosService.getAlunoComINEP(this.form.codigo_inep);
        if (!aluno) return;

        if (aluno.configuracao_id !== this.user.configuracao_id) {
          this.confirmarTransferenciaDeAluno(aluno);
          return;
        }

        this.avisarAlunoJaCadastrado();
      } catch (error) {
        this.$handleError(error);
      }
    },

    /**
     * Oferece a transferência quando o INEP informado pertence a um aluno de
     * outra escola.
     * --
     * @param {object} aluno - Aluno encontrado pelo código INEP
     */
    confirmarTransferenciaDeAluno(aluno) {
      this.$modals.warn({
        title: "Você gostaria de transferir esse(a) aluno(a)?",
        message: `Encontramos o(a) aluno(a) <strong>${aluno.nomecompleto}</strong> com INEP <strong>${aluno.codigo_inep}</strong> registrado em outra escola, você gostaria de transferí-lo para sua escola?`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            callback: async () => {
              this.$modals.setOptions({ loading: true });
              await this.$services.alunosService.atualizarAluno({
                ...aluno,
                configuracao_id: this.user.configuracao_id,
              });
              this.$modals.close();
              this.$toast.success("Aluno transferido com sucesso!");
              this.$router.push({ name: "alunos" });
            },
            props: {
              color: "success",
              small: true,
            },
          },
        ],
      });
    },

    avisarAlunoJaCadastrado() {
      this.$modals.info({
        title: "Este(a) aluno(a) já está cadastrado na sua escola!",
        message: "Verificamos que este(a) aluno(a) já está cadastrado na sua escola, ",
        buttons: [
          {
            text: "Confirmar",
            callback: () => {
              this.$modals.close();
              this.$toast.info("Este(a) aluno(a) já está cadastrado na sua escola");
              this.$router.push({ name: "alunos" });
            },
            props: {
              color: "success",
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey;
  /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue;
  /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
